import {useSelector} from 'react-redux';
import {selectUsers} from './useUsers';

export function useIndexedUsers() {
    return useSelector(selectUsers);
}
